"use client";

import { LazyMotion, m, domAnimation } from "framer-motion";
import { ReactNode } from "react";

type StaggerContainerProps = {
  children: ReactNode;
  className?: string;
  staggerDelay?: number;
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24,
    scale: 0.96
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94] as const,
    },
  },
};

export function StaggerContainer({ children, className }: StaggerContainerProps) {
  return (
    <LazyMotion features={domAnimation}>
      <m.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className={className}
      >
        {children}
      </m.div>
    </LazyMotion>
  );
}

// oxlint-disable-next-line react-doctor/no-multi-comp -- deferred: refactor tracked
export function StaggerItem({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <LazyMotion features={domAnimation}>
      <m.div variants={itemVariants} className={className}>
        {children}
      </m.div>
    </LazyMotion>
  );
}

type FadeSlideUpProps = {
  children: ReactNode;
  delay?: number;
  className?: string;
};

// oxlint-disable-next-line react-doctor/no-multi-comp -- deferred: refactor tracked
export function FadeSlideUp({ children, delay = 0, className }: FadeSlideUpProps) {
  return (
    <LazyMotion features={domAnimation}>
      <m.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.6,
          delay,
          ease: [0.25, 0.46, 0.45, 0.94],
        }}
        className={className}
      >
        {children}
      </m.div>
    </LazyMotion>
  );
}
